import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getOffices = (): Promise<ISelectModel<string>[]> =>
  API.get(`api/offices/all`).then(response => response?.data);
